module.exports = __webpack_public_path__ + "img/product-flyer.e36c8e3a.svg";